import { useMutation } from '@tanstack/react-query'

import { deleteBooking } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type MutationPayload = {
  bookingId?: ParameterID
}

export function useMutationDeleteBooking() {
  return useMutation({
    mutationKey: ['MutationDeleteBooking'],
    mutationFn: async ({ bookingId }: MutationPayload) =>
      await deleteBooking(bookingId ?? ''),
  })
}
